import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { IconButton } from '@components/main-components/icon-buttons/IconButton';

export const CarouselArrow = ({
  ariaLabel,
  onClick = () => null,
  disabled,
}: {
  ariaLabel: string;
  onClick?: (e?: React.MouseEvent) => void;
  disabled?: boolean;
}) => (
  <div className="rounded-full shadow-high">
    <IconButton
      variant="secondary"
      aria-label={ariaLabel}
      onClick={onClick}
      disabled={disabled}
      size={42}
      iconSize={20}
      icon={<FontAwesomeIcon icon={faAngleDown} />}
    />
  </div>
);
